import {formatPrice} from "@/helpers";

export const PROPERTY_TYPES = [
    'Apartment',
    'Storage',
    'House',
    'Office',
    'Pod',
    'Rental Truck',
    'Condo',
    'Town-home',
    'Other'
]

export const PARKING_DISTANCES = {
    '20': 'Just a Few Steps (0-20 Feet)',
    '50': 'A Brief Jaunt (21-50 Feet)',
    '100': 'Bit of a Hoof (51-100 Feet)',
    '150': 'We’ll Skip The Gym (100+ Feet)'
}

export const PROPERTY_TYPES_WITH_FLOORS = [
    'apartment',
    'storage',
    'office',
    'condo',
    'other'
]

export const PROPERTY_TYPES_WITH_STORIES = [
    'house',
    'town-home'
]

export const PROPERTY_TYPES_WITH_SQFT = [
    'condo',
    'apartment',
    'house',
    'town-home'
]

export const PROPERTY_TYPES_WITH_OPT_SIZE = [
    'house',
    'town-home'
]

export const PROPERTY_TYPES_WITH_OPT_SQFT = [
    'apartment',
    'condo'
]

export const PROPERTY_TYPES_WITH_ELEVATOR = [
    'apartment',
    'storage',
    'office',
    'condo',
    'other'
]

export const ALLOWED_SIZES = {
    "SquareFeet": /^\d+\s?(sqft)?$/i,
    "StandardLinear": [
        "10 ft",
        "14 ft",
        "17 ft",
        "24 ft",
        "26 ft",
        "Over",
    ],
    "StandardSquare": [
        "5x5 ft",
        "5x10 ft",
        "10x10 ft",
        "15x10 ft",
        "10x20 ft",
        "Over"
    ],
    "BedroomCount": [
        "1 bedroom",
        "2 bedroom",
        "3 bedroom",
        "4+ bedrooms"
    ]
};

export const LOCATION_TYPE_TO_SIZE_MAP = {
    'apartment': 'BedroomCount',
    'storage': 'StandardSquare',
    'pod': 'StandardLinear',
    'rental_truck': 'StandardLinear',
    'condo': 'BedroomCount',
    'town-home': 'BedroomCount',
    'house': 'BedroomCount',
    'other': 'SquareFeet',
};

export const MERGE_TAG_MAP = {
    'date': 'chosen_date.formatted',
    'reason': 'inestimable_reason',
    'time': 'chosen_time.time',
    'branch_phone': 'branch.phone',
    'branch_name': 'branch.name',
    'branch_email': 'branch.email',
    'estimate_rate': (state) => state.availability?.adjustedRate || state.estimate?.rate * state.estimate?.movers || 1,
    'estimate_base_rate': 'estimate.rate',
    'estimate_duration': 'estimate.totalTime',
    'estimate_total': (state) => formatPrice(state.estimate.totalCost)
}

export const API_ENDPOINT_PREFIX = 'api/v3/booking-form/'
export const API_ENDPOINTS = {
    'address' : 'address',
    'items' : 'items',
    'date' : 'date',
    'contact' : 'contact',
    'reservation' : 'reservation',
    'book' : 'book',
    'send': 'send-quote'
}

export const REFERRAL_OPTIONS = [
    'Yelp',
    'Google',
    'Word of Mouth',
    'Facebook',
    'Nextdoor',
    'Other Search Engine',
    'Saw our truck',
    'Billboard',
    'Mailers',
    'Radio Ad',
    'Smart City',
    'Repeat Customer',
    'Other Social Media',
    'Lenox Burnet Luxury Apartments',
    'Other'
]


